import React from 'react';
import {
  EnvelopeIcon,
  CalendarDaysIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import OperationalMetricStrip from '../ui/OperationalMetricStrip';

// ✅ BEST-OF-BEST: Simplified Stats - "Who can work today?" focused
// GPT Guidance: Max 5 tiles, each answers a daily decision question
export const EmployeesStats = ({ analytics, setStatusFilter, setActiveTab, statusFilter, activeTab }) => {
  return (
    <OperationalMetricStrip
      items={[
        { key: 'schedulable', icon: CalendarDaysIcon, label: 'Schedulable', value: analytics.schedulableEmployees || 0, detail: 'Can be assigned to jobs', tone: 'emerald', onClick: () => setStatusFilter('schedulable'), active: statusFilter === 'schedulable' },
        { key: 'pending', icon: EnvelopeIcon, label: 'Pending Invites', value: analytics.pendingInvites, detail: 'Awaiting account setup', tone: 'orange', onClick: () => setStatusFilter('pending'), active: statusFilter === 'pending' },
        { key: 'time-off', icon: ChartBarIcon, label: 'Time Off', value: analytics.ptoRequestsCount, detail: 'Upcoming time off — blocks scheduling', tone: 'purple', onClick: () => setActiveTab('pto-management'), active: activeTab === 'pto-management' },
      ]}
    />
  );
};
